import { approvalDocumentApi, } from "../api/generated/wrappers/approval-document";
import { createQueryKeys } from "./create-query-keys";
const approvalDocumentQueryKeys = createQueryKeys("approvalDocument", {
    list: (params) => ({
        queryKey: ["list", params],
        queryFn: async () => await approvalDocumentApi.getApprovalDocuments(params),
    }),
    detail: (id) => ({
        queryKey: ["detail", id],
        queryFn: async () => await approvalDocumentApi.getApprovalDocument(id),
    }),
    process: (id) => ({
        queryKey: ["process", id],
        queryFn: async () => await approvalDocumentApi.getApprovalDocumentProcess(id),
    }),
    processList: (params) => ({
        queryKey: ["processList", params],
        queryFn: async () => await approvalDocumentApi.getProcessList(params),
    }),
    productsForInbound: (id) => ({
        queryKey: ["productsForInbound", id],
        queryFn: async () => await approvalDocumentApi.getProductsForInbound(id),
    }),
});
export default approvalDocumentQueryKeys;
